export const DOWNLOAD_APP_BANNER_DISMISSED = 'downloadAppBannerDismissed';
